// src/features/tutor/PreviewPanel.js
// Embeddable read-only content viewer — same logic as UnitPreview.js
// but receives lessonId and unitId as props instead of URL params.
import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useUnitNavigation } from '../../hooks/useUnitNavigation';
import { ProgressBar } from '../learner/components/Navigation/ProgressBar';
import { UnitNavigation } from '../learner/components/Navigation/UnitNavigation';
import { ContentRenderer } from '../learner/components/ContentRenderers/ContentRenderer';
import '../learner/UnitViewer.css';

function PreviewPanel({ lessonId, unitId }) {
  const { currentUser } = useAuth();

  const {
    loading,
    currentUnitIndex,
    currentInternalIndex,
    allContent,
    getCurrentContent,
    getInternalContent,
    goToNextUnit,
    goToPrevUnit,
    goToInternalIndex,
    touchHandlers
  } = useUnitNavigation(lessonId, currentUser, unitId);

  if (!lessonId) {
    return (
      <div className="preview-panel-message">
        No lesson information available for this unit.
      </div>
    );
  }

  if (loading) {
    return (
      <div className="preview-panel-message">
        Loading content…
      </div>
    );
  }

  const currentContent = getCurrentContent();
  const internalContent = getInternalContent();

  return (
    <div className="unit-viewer" {...touchHandlers}>
      <ProgressBar
        currentIndex={currentUnitIndex}
        totalUnits={allContent.length}
        internalIndex={currentInternalIndex}
        internalTotal={internalContent.length}
      />

      {currentContent?.title && internalContent.length > 1 && (
        <div className="package-title-display">
          <span className="package-title-text">{currentContent.title}</span>
        </div>
      )}

      <div className="main-content">
        <ContentRenderer
          content={
            internalContent.length > 0
              ? internalContent[currentInternalIndex]
              : currentContent
          }
          userAnswers={{}}
          showFeedback={false}
          completedUnits={[]}
          selectedHotspot={null}
          visitedHotspots={[]}
          currentInternalIndex={currentInternalIndex}
          internalContent={internalContent}
          onAnswerSelect={() => {}}
          onCheckAnswer={() => {}}
          onMarkCompleted={() => {}}
          onHotspotClick={() => {}}
          onPlayAudio={() => {}}
          onSetSelectedHotspot={() => {}}
          getRandomizedOptions={() => []}
        />
      </div>

      <UnitNavigation
        currentIndex={currentUnitIndex}
        internalIndex={currentInternalIndex}
        totalUnits={allContent.length}
        internalContent={internalContent}
        visitedPages={new Set()}
        visitedUnits={new Set()}
        completedUnits={{}}
        currentContent={currentContent}
        onPrevUnit={goToPrevUnit}
        onNextUnit={goToNextUnit}
        onInternalNavigation={goToInternalIndex}
        onGoToInternal={goToInternalIndex}
        hideUnitArrows={true}
      />
    </div>
  );
}

export default PreviewPanel;